export const sheetAccents = [
  '#e8a860',
  '#5cbf8a',
  '#6aa4e8',
  '#e07a8a',
  '#a78bda',
  '#3db8b0',
  '#e08a45',
  '#d45c5c',
  '#c4b84a',
  '#e0a0d4',
]

export function sheetAccent(index) {
  return sheetAccents[index % sheetAccents.length]
}
